<template>
    <div class="orp-list">
        <div class="filters">
            <div class="filter filter--reset">
                <img src="/images/rates/close.svg" alt="" />
                <span>Сбросить фильтры</span>
            </div>
            <div class="filter departments">
                <span>Отделы</span>
                <img src="/images/rates/filters/departments.svg" alt="" />
                <div class="departments_view">
                    <!-- Тут будет всплывающее окно со списком всех отделов -->
                </div>
            </div>
            <div class="filter dates">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="label" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="dates" locale="ru-Ru" :first-day-of-week="1" range color="orange lighten-1"
                        ><v-btn text color="primary" @click="menu2 = false"> Отмена </v-btn
                        ><v-btn text color="primary" @click="save()"> Готово </v-btn></v-date-picker
                    >
                </v-menu>
            </div>
            <div class="filter emotions">
                <span>Эмоции</span>
                <img src="/images/rates/filters/departments.svg" alt="" />
            </div>
        </div>
        <div class="orp-screen">
            <OrpRate v-for="orp in filtered_by_low" :key="orp._id" :orp="orp" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrpRate from './OrpRate.vue'

export default {
    name: 'OrpList',
    data: () => ({
        menu2: false,
        label: 'Период',
        dates: [],
        out_dates: [],
    }),
    components: { OrpRate },
    computed: {
        ...mapGetters(['get_rates_by_rate']),
        filtered_by_low() {
            return this.get_rates_by_rate('low', this.out_dates)
        },
    },
    beforeMount() {
        // this.load_rates()
        if (localStorage.getItem('title') != 'admin' && localStorage.getItem('title') != 'orp')
            this.$router.push('/rates')
    },
    methods: {
        // ...mapActions(['load_rates']),
        get_image_or_color(rates, type) {
            if (rates) {
                let rates_array = {}

                const low = rates.filter((rate) => rate.rate == '1')
                const middle = rates.filter((rate) => rate.rate == '2')
                const high = rates.filter((rate) => rate.rate == '3')

                rates_array.low = ((low.length / rates.length) * 100).toFixed()
                rates_array.middle = ((middle.length / rates.length) * 100).toFixed()
                rates_array.high = ((high.length / rates.length) * 100).toFixed()

                const max = Object.keys(rates_array).reduce((a, b) => (rates_array[a] * 1 > rates_array[b] * 1 ? a : b))

                switch (max) {
                    case 'low':
                        return type == 'image' ? '/images/ants/1-1.png' : 'blue'
                        break
                    case 'middle':
                        return type == 'image' ? '/images/ants/3-1.png' : 'red'
                        break

                    case 'high':
                        return type == 'image' ? '/images/ants/4-1.png' : 'green'
                        break
                    default:
                        break
                }
            } else {
                return ''
            }
        },

        save() {
            this.label = ''
            this.dates.forEach((date, index) => {
                this.label +=
                    index != this.dates.length - 1
                        ? `${new Date(date).toLocaleDateString('ru-RU')} - `
                        : new Date(date).toLocaleDateString('ru-RU')
            })
            // this.label = this.dates.join('-')
            this.out_dates = this.dates
            this.menu2 = false
        },

        get_count(rates, type) {
            if (rates) {
                let x = []
                switch (type) {
                    case 'low':
                        x = rates.filter((rate) => rate.rate == '1')
                        break
                    case 'middle':
                        x = rates.filter((rate) => rate.rate == '2')
                        break
                    case 'high':
                        x = rates.filter((rate) => rate.rate == '3')
                        break

                    default:
                        break
                }

                return x.length
            }
        },
    },
}
</script>

<style scoped>
.orp-list {
    width: 1214px;
    margin: 0 auto;
}

.filters {
    display: flex;
    justify-content: space-between;
    height: 60px;
    margin-bottom: 30px;
}

.filters .filter {
    width: 296px;
    display: flex;
    align-items: center;
}

.filters .filter--reset {
    cursor: pointer;
}

.filters .filter--reset img {
    width: 10px;
    margin-right: 15px;
}

.filters .filter--reset span {
    font-size: 18px;
}

.filters .filter.departments,
.filters .filter.dates,
.filters .filter.emotions {
    background: #ffffff;
    border-radius: 30px;
    padding: 16px 30px;
    font-size: 22px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    position: relative;
}

.orp-screen {
    height: 650px;
    overflow-y: auto;
}
</style>

<!-- Сори что так вынес, это при клике на input в календаре -->
<style>
.v-input__slot {
    color: orange !important;
}
</style>
